/**
 * Search result skeleton — matches the ParticipantCard layout used for
 * P2P search results (avatar + name + @username on the left).
 */
export default function UserSearchSkeleton() {
  return (
    <div className="flex items-center justify-between gap-3 py-2.5 px-3 rounded-xl bg-white/[0.04]">
      <div className="flex items-center gap-3 min-w-0 flex-1">
        {/* Avatar */}
        <div className="skeleton size-10 rounded-full shrink-0" />
        <div className="flex flex-col gap-1.5 min-w-0 flex-1">
          {/* Name */}
          <div className="skeleton h-3.5 w-2/3 rounded-md" />
          {/* @username */}
          <div className="skeleton h-3 w-1/3 rounded-md opacity-70" />
        </div>
      </div>
    </div>
  );
}
